module.exports = __webpack_public_path__ + "static/media/recorte-2.dce11a1d.png";